export default __webpack_public_path__ + "static/img/download_app_access_image.9947afa.png";